import { BaseFileModel } from '../data';

export interface EmailCampaignFilesPayloadModel {
  files: BaseFileModel[];
}
